import Cover from "../../components/Cover/Cover";
import "./ProductPage.css";
import ProteinsIcon from "../../assets/icons/ProteinsIcon.png";
import FatsIcon from "../../assets/icons/FatsIcon.png";
import CarbohydratesIcon from "../../assets/icons/CarbohydratesIcon.png";
import kcalIcon from "../../assets/icons/kcalIcon.png";
import shoppingCartIcon from "../../assets/icons/shopping_cart.png";
import servicePageDecoration from "../../assets/icons/servicePageDecoration.png";
import { Link, useLocation } from "react-router-dom";

export const nutritionMeta = [
  { icon: ProteinsIcon },
  { icon: FatsIcon },
  { icon: CarbohydratesIcon },
  { icon: kcalIcon },
];

const texts = {
  ua: {
    goToStore: "Перейти до магазину",
    otherProducts: "Інші товари категорії",
    nutrition: ["Білки", "Жири", "Вуглеводи", "Калорії"], 
  },
  ru: {
    goToStore: "Перейти в магазин",
    otherProducts: "Другие товары категории",
    nutrition: ["Белки", "Жиры", "Углеводы", "Калории"],
  },
};


const ProductPage = ({
  metaTitle,
  metaDescription,
  coverImage,
  coverImageMobile,
  coverTitle,
  aboutImage,
  aboutTitle,
  aboutStats,
  aboutLink,
  aboutInformation,
  categoryInfo,
  path,
  category,
  productPageLang,
}) => {
  const isMobile = window.innerWidth <= 1199;
  const coverImageToUse = isMobile ? coverImageMobile : coverImage;
  function shuffleArray(array) {
    return [...array].sort(() => Math.random() - 0.5);
  }

  const location = useLocation();
  const currentLang = location.pathname.startsWith("/ru") ? "ru" : "ua";
  const langPrefix = currentLang === "ru" ? "/ru" : "";
  const t = texts[currentLang];

  const relatedProducts = productPageLang.filter(
    (p) => p.category === category && p.path !== location.pathname
  );

  const randomRelated = shuffleArray(relatedProducts).slice(0, 2);

  return (
    <div className="product__page">
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <Cover src={coverImageToUse} text={coverTitle} />
      <div className="product__page-about">
      <h1 className="product__page-about-title-mobile mont-m">{aboutTitle}</h1>
        <div className="product__page-about-image-wrapper">
          <img
            src={aboutImage}
            alt={aboutTitle}
            className="product__page-about-image"
          />
        </div>
        <div className="product__page-about-info">
          <h1 className="product__page-about-title mont-m">{aboutTitle}</h1>
          <div className="product__page-about-info-stats">
          {aboutStats.map((stat, idx) => (
  <div key={idx} className="product__page-about-info-stat">
    <img
      src={nutritionMeta[idx].icon}
      alt={t.nutrition[idx]}      
      className="product__page-about-info-stat-icon"
    />
    <div className="product__page-about-info-stat-text">
      <span className="product__page-about-info-stat-label int-sb">
        {t.nutrition[idx]}
      </span>
      <span className="product__page-about-info-stat-number int-r-21">
        {stat}
      </span>
    </div>
  </div>
))}

          </div>
          {/* <a
            href={aboutLink}
            className="product__page-about-info-link int-sb"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={shoppingCartIcon}
              alt="іконка продуктової корзини"
              className="shopping__cart-produc-icon"
            />
            <p>{t.goToStore}</p>
          </a> */}
          <div className="product__page-about-info-additional">
            {aboutInformation.map((info, idx) => (
              <div
                key={idx}
                className="product__page-about-info-additional-item"
              >
                <span className="product__page-about-info-additional-item-title int-sb">
                  {info.title}
                </span>
                <span className="product__page-about-info-additional-item-desc int-r-21">
                  {info.desc}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <section className="product__page-category-info-section">
        <img
          src={servicePageDecoration}
          alt="фото банки з молоком"
          className="product__page-category-info-section-decoration"
        />
        <img
          src={servicePageDecoration}
          alt="фото банки з молоком"
          className="product__page-category-info-section-decoration two"
        />
        <img
          src={servicePageDecoration}
          alt="фото банки з молоком"
          className="product__page-category-info-section-decoration three"
        />
        <img
          src={servicePageDecoration}
          alt="фото банки з молоком"
          className="product__page-category-info-section-decoration four"
        />
        {categoryInfo.map((info, idx) => (
          <p
            key={idx}
            className="product__page-category-info-section-text mont-r"
          >
            {info}
          </p>
        ))}
      </section>
      {productPageLang.filter((p) => p.category === category).length > 2 && (
        <section className="related__products">
          <h2 className="related__products-title mont-m">
            {t.otherProducts}
          </h2>
          <div className="related__products-list">
            {randomRelated.map((prod, idx) => (
              <Link
                to={prod.path}
                key={idx}
                className="related__products-item mont-m"
              >
                <div className="related__products-item-image-wrapper">
                  <img
                    className="related__products-item-image"
                    src={prod.aboutImage}
                    alt={prod.aboutTitle}
                  />
                </div>
                <p className="related__products-item-text">{prod.aboutTitle}</p>
              </Link>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default ProductPage;
